module.exports = __webpack_public_path__ + "static/dunkin-recipegrid-off-bdf118f574f3902b4ee225795dd79912.png";